export default __webpack_public_path__ + "img/9e576501bd3cd10cff9fdd2455568ea0.svg";